import { AvatarBadge, type AvatarBadgeProps } from '@chakra-ui/react'

type OnlineBadgeSize = 'xs' | 'md'

const SIZE_TO_UI_DETAILS: Record<
  OnlineBadgeSize,
  { boxSize: AvatarBadgeProps['boxSize']; borderWidth: AvatarBadgeProps['borderWidth'] }
> = {
  xs: {
    boxSize: '0.75em',
    borderWidth: '2px',
  },
  md: {
    boxSize: '1em',
    borderWidth: '2px',
  },
}

export default function AvatarOnlineBadge({
  size = 'md',
}: {
  size?: OnlineBadgeSize
}): JSX.Element {
  const { boxSize, borderWidth } = SIZE_TO_UI_DETAILS[size]

  return <AvatarBadge boxSize={boxSize} bg="success.solid" borderWidth={borderWidth} />
}
